import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import { useCmsData } from '../../../../context/CmsContext.js';
import { SizeGuideModalView } from './SizeGuideModalView.js';

const SizeGuideModalContainer = ()=>{
    const { isVtoEnabled , isFrameSizeVTOEnabled  } = useFeatureToggles();
    const { sizeGuideDocument  } = useCmsData();
    const { activeVariant: { sku , displayName  } ,  } = useProductData();
    return /*#__PURE__*/ React.createElement(SizeGuideModalView, {
        sku: sku,
        isVtoEnabled: isVtoEnabled && isFrameSizeVTOEnabled,
        sizeGuideContent: sizeGuideDocument,
        productName: displayName
    });
};

export { SizeGuideModalContainer };
//# sourceMappingURL=SizeGuideModalContainer.js.map
